/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.getTimeline'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 1 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  algorithm: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  feed: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<FeedDefs.FeedViewPost>(
      (() => FeedDefs.feedViewPost) as any,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get a view of the requesting account's home timeline. This is expected to be some form of reverse-chronological feed. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
